/*
 *		Copyright (c) 2011-2015 Acronis Incorporated. All rights reserved.
 *
 *	This source code may be used only by organizations licensed to use Acronis Access, in conjunction with normal Acronis Access usage.
 *	No portion of it may be redistributed or modified without the written permission of Acronis, Inc. See the Acronis Software License Agreement for more information.
 */

'use strict';

angular.module('access.Nodes')
    .directive('accLinkProperties', ['template', (template) => ({
        templateUrl: template('nodes/_link_properties'),
        controller: ['$scope', function ($scope) {
            $scope.handlePublicTypeChange = (link) => link.allow_guest_downloads = true;
        }]
    })]);
